
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';


import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { DynamicDialogModule } from 'primeng-lts/dynamicdialog';
import { DirectivesModule } from '../../directives/directives.module';
import { WaitLoadingModule } from '../../components/common/waitLoading/waitLoading.module';
import { A11yModule } from '@angular/cdk/a11y';
import { SubHeaderModule } from '../../components/common/sub-header/sub-header.module';
import { FormPlycaModule } from '../../components/forms/formPlyca.module';
import { SET_VARIABLES } from './setVariables.component';
import { ScrollPanelModule } from 'primeng-lts/scrollpanel';
import { TabViewModule } from 'primeng-lts/tabview';
import { DossierHeaderModule } from '../components/dossierHeader.module';


@NgModule({
  declarations: [SET_VARIABLES],
  imports: [TranslateModule, CommonModule, FormsModule,
    DynamicDialogModule,
    DirectivesModule, WaitLoadingModule, A11yModule,
    FormPlycaModule,
    // HelpModule,
    SubHeaderModule, ScrollPanelModule, TabViewModule],
  exports: [SET_VARIABLES]
})
export class SetVariablesModule { }
